import { forwardRef } from 'react';
import { Card as MuiCard, CardActionArea } from '@mui/material';
import { Box } from '../../Box';
import cardStyleBuilder, { resolvePadding } from './cardStyleBuilder';
import { mergeSxStyle } from '../../common/mergeSxStyle';
import { CardContainer } from './CardContainer';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { cardActionAreaDefaultStyle } from './cardDefaultStyle';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
export const Card = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    className,
    id,
    sx,
    mediaPosition,
    media,
    footer,
    header,
    content,
    padding,
    primaryAction,
    width,
    ...rest
  } = _ref;
  const theme = useInterstateTheme();
  const style = mergeSxStyle(cardStyleBuilder(theme, mediaPosition, width), sx);
  const mediaComponent = mediaPosition ? media : null;

  // If the card is a primary action card then it is wrapped with a CardActionArea
  const Container = primaryAction ? CardActionArea : CardContainer;
  const ContainerSx = primaryAction ? cardActionAreaDefaultStyle(theme) : {};
  const containerStyle = mergeSxStyle({
    width
  }, ContainerSx);
  return /*#__PURE__*/_jsx(Container, {
    onClick: primaryAction,
    component: 'button',
    sx: containerStyle,
    children: /*#__PURE__*/_jsxs(MuiCard, {
      className: className,
      id: id,
      square: false,
      ref: ref,
      sx: style,
      variant: "outlined",
      "data-testid": rest['data-testid'],
      children: [/*#__PURE__*/_jsxs(Box, {
        className: 'card-media-header-content-container',
        sx: {
          display: 'flex',
          flexDirection: mediaPosition === 'left' ? 'row' : 'column'
        },
        children: [mediaComponent, /*#__PURE__*/_jsxs(Box, {
          className: 'card-header-content-container',
          sx: {
            '&.card-header-content-container': {
              display: 'flex',
              flexDirection: 'column',
              padding: resolvePadding(padding, media, mediaPosition)
            }
          },
          children: [header, content]
        })]
      }), footer, children]
    })
  });
});
Card.displayName = 'Card';